const Spanish = {
  // "Hello StackBlitz!": "Hallo StackBlitz!",
  // "Start editing to see some magic happen":
  //   "Beginnen Sie mit der Bearbeitung, um zu sehen, wie etwas Magie passiert",
  //   "Login": "Einloggen"
  "Yesterday with": "Subhas",
  'and': '123',
  'concert in LA. Was  totally fantastic! People were really excited about  this one!': '.....................................................',
  '#MotivationMonday': '#MotivationMonday',
  '#Morning': '#Morning',
  "Reference site about Lorem Ipsum, giving information on its origins, as well as  a random Lipsum generator.Reference site about Lorem  Ipsum, giving information on its origins, as well as  a random Lipsum generator.Reference site about Lorem  Ipsum, giving information on its origins, as well as  a random Lipsum generator.": "386423786429846289764987264987394785693748597834y59783495",
  "English(en)": "Europe (eu)",
  "Announcements": "ingelesa ",
  "Featured Posts": "Iragarkiak",
  "Action Required": "Nabarmendutako argitalpenak",
  "more liked this": "Beharrezko ekintza",
  "Comments": "gehiago gustatu zaio hau",
  "Awards": "Iruzkinak",
  "Upcoming Birthdays": "Sariak",
  "Upcoming Work-Anniversaries": "Datozen urtebetetzeak",
  "Popular Posts": "Datozen Lan-Urteurrenak",
  "Upcoming Wedding Anniversaries": "Mezu ezagunak",
  "Reference site about lorem ipsum, giving information": "Datozen Ezkontza Urteurrenak",
  "Follow Up Suggestions": "Lorem ipsum-i buruzko erreferentzia gunea, informazioa emanez..",
  "Feed": "Jarraitu iradokizunak",
  "Post": "Elikadura",
  "My Feeds": "Argitalpena",
  "Feed Detail": "Nire jarioak",
  "Featured": "Jarioaren xehetasuna",
  "Pop. Posts": "Nabarmena",
  "Apply": "Pop. Mezuak",
  "Team Leaves": "Aplikatu",
  "My Leaves": "Taldeko bajak",
  "Hello": "Nire hostoak",
  "Leave Ledger": "Kaixo",
  "Org Leaves": "Utzi Ledger",
  "Employees": "Org Hostoak",
  "All Teams": "Langileak",
  "My Team": "Talde guztiak",
  "Log Out": "Nire taldea",
  "Awards": "Saioa amaitu",
  "Quick Actions": "Sariak",
  "Ticket Management": "Ekintza azkarrak",
  "Ticket Detail": "Sarreren kudeaketa",
  "My Tickets": "Txartelaren xehetasuna",
  "Add Ticket": "Nire Sarrerak",
  "Ticket Detail": "Gehitu txartela",
  "Leave": "Txartelaren xehetasuna",
  "Apply": "Utzi",
  "My Leaves": "Aplikatu",
  "Team Leaves": "Nire hostoak",
  "Org Leaves": "Taldeko bajak",
  "Leave Ledger": "Org Hostoak",
  "My Leave Completed Leave": "Utzi Ledger",
  "Gallery": "Nire baja amaituta",
  "Single Gallery": "Galeria",
  "Add Media": "Galeria Bakarra",
  "Hr Assessment": "Gehitu multimedia",
  "My Assessment": "Hr Ebaluazioa",
  "EmployeeAssessment": "Nire Ebaluazioa",
  "Hr Assessment": "Langileen Ebaluazioa",
  "Recruitment": "Hr Ebaluazioa",
  "Recruitment Dashboard": "Kontratazioa",
  "Recruitment Details": "Kontratazio panela",
  "Create Position": "Kontratazio Xehetasunak",
  "Applicant Details": "Sortu posizioa",
  "Add Applicant": "Eskatzailearen xehetasunak",
  "Applicant Search": "Gehitu eskatzailea",
  "Work From Home": "Eskatzaileen bilaketa",
  "Work From Home Dashboard": "Etxetik Lana",
  "My Work From Home": "Etxetik lan egiteko panela",
  "Team Work From Home": "Nire Lana Etxetik",
  "Completed": "Talde Lana Etxetik",
  "Pending": "Osatua",
  "More": "Zain",
  "Communication Panel": "Gehiago",
  "Create Reminders": "Komunikazio Panela",
  "Reminders": "Sortu abisuak",
  "First time dashboard": "Oroigarriak",
  "Audit Trails": "Lehenengo aldiz aginte-panela",
  "Create Owner Page": "Ikuskaritza Pista",
  "Account Owner Page": "Sortu jabe-orria",
  "Change Password": "Kontuaren jabearen orria",
  "OTP Verification": "Aldatu pasahitza",
  "Policy": "OTP egiaztapena",
  "AddPolicy": "Politika",
  "Policies": "GehituPolicy",
  "Policydetail": "Politikak",
  "All Teams": "Politikaren xehetasuna",
  "My Teams": "Talde guztiak",
  "New": "Nire Taldeak",
  "Self Learning": "Berria",
  "Instructor Training": "Autoikaskuntza",
  "Task Management": "Irakasleen Prestakuntza",
  "Task Detail": "Zereginen kudeaketa",
  "Search": "Zereginaren xehetasuna",
  "Search Result": "Bilatu",
  "What would you like to search": "Bilaketa-emaitza",
  "Search Employee & their post": "Zer bilatu nahiko zenuke",
  "Profile": "Bilatu langilea eta haien argitalpena",
  "Change password": "Profila",
  "Send Us Feedback": "Aldatu pasahitza",
  "2022 © OrgGenie - Your Organization Portal. Powered By": "Bidali Iritzia",
  "BizBrolly": "2022 © OrgGenie - Zure Erakundearen Ataria. Powered By",
  "Version 16.6": "BizBrolly",
  "Log Out": "16.6 bertsioa",
  "Add App": "Saioa amaitu",
  "App Title": "Gehitu aplikazioa",
  "Links": "Aplikazioaren izenburua",
  "Existing App": "Estekak",
  "Apps": "Lehendik dagoen aplikazioa",
  "Decline": "Aplikazioak",
  "Save": "Gainbehera",


};

export default Spanish;
